import BaseInput from "./baseInput.js";
import translate2 from "../translations/translationMain.js";
import useColors from "../customHooks/useColors.js";

import { useEffect, useRef } from "react";

const BaseDropdown2 = ({
  value = "",
  onChange = (e) => {},
  translate = true,
  translateSufix = false,
  translatePrefix = false,
  elements = [],
  style = {},
  readOnly = false,
  afterValueChanged = () => {},
  placeholder = null,
  hasFormWrapper = true,
  includeNull = false,
  sortFunction = (a, b) => { 
    return a.name.localeCompare(b.name);
  } //stavi () => {} ako oces da ide tak kak je dosel array inicijalno
}) => {
  const selectRef = useRef();
  const [currentColors] = useColors();

  useEffect(() => {
    afterValueChanged(selectRef);
  }, [value]);

  const calculateName = (pName, pPrefix, pSufix) => {
    let name = "";

    if (pPrefix) {
     
      if (translatePrefix) {
        name += translate2({ key: pPrefix }) ?? "";
      } else {
        name += pPrefix;
      }
      name += " ";

    }

    if (translate) {
      name += translate2({ key: pName });
    } else {
      name += pName;
    }

    if (pSufix) {
      name += " ";

      if (translateSufix) {
        name += translate2({ key: pSufix }) ?? "";
      } else {
        name += pSufix;
      }
    }

    return name ?? "";
  };

  const enhanchedElements = [...elements].map((element) => {
    return {
      ...element,
      trueName: translate ? translate2({ key: element.name }) : element.name,
      name: calculateName(
        element.name,
        element.optionPrefix,
        element.optionSufix
      ),
    };
  });

  enhanchedElements.sort(sortFunction);

  if (includeNull) {
    enhanchedElements.unshift({ key: null, value: "", name: "", trueName: "" });
  }

  if (readOnly) {
    return (
      <div style={{ textAlign: "center" }}>
        <BaseInput
       
          readOnly
          style={{
            textAlign: "center",
          }}
          value={
            elements.find((element) => element.value === value)?.name ?? ""
          }
          translate={translate}
        />
      </div>
    );
  }

  const currentEnchantedElement =
    enhanchedElements.find((element) => element.value === value) ?? {};

  return (
    <BaseInput
      hasFormWrapper={hasFormWrapper}
      value={value}
      type="select"
      placeholder={placeholder}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      innerRef={selectRef}
      style={{
        paddingBottom: "0px",
        paddingLeft: hasFormWrapper ? "5px" : "10px",
        color: currentColors.tertiary,
        backgroundColor: currentColors.quinary,
        paddingTop: hasFormWrapper ? "30px" : "0px",
        cursor: "pointer",
        ...style,
      }}
    >
      {currentEnchantedElement.trueName !== currentEnchantedElement.name && (
        <option disabled value={value}>
          {currentEnchantedElement.trueName}
        </option>
      )}
      {enhanchedElements.map((element) => {
        return (
          <option
            key={element.key === undefined ? element.value : element.key}
            value={element.value}
          >
            {element.name}
          </option>
        );
      })}
    </BaseInput>
  );
};

export default BaseDropdown2;
